export default __webpack_public_path__ + "8aeb3ab76b98989c86626ffbaa8ed6c4.svg";